import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index')
    },
    {
      path: '/aiChineseMedicine/evaluation',
      name: 'aiChineseMedicineEvaluation',
      component: () => import('@/views/aiChineseMedicine/evaluation/index')
    },
    {
      path: '/aiChineseMedicine/face',
      name: 'aiChineseMedicineFace',
      component: () => import('@/views/aiChineseMedicine/face/index')
    },
    {
      path: '/aiChineseMedicine/tongue',
      name: 'aiChineseMedicineTongue',
      component: () => import('@/views/aiChineseMedicine/tongue/index')
    },
    {
      path: '/aiChineseMedicine/inquiry',
      name: 'aiChineseMedicineInquiry',
      component: () => import('@/views/aiChineseMedicine/inquiry/index')
    },
    {
      path: '/aiChineseMedicine/questionnaire',
      name: 'questionnaire',
      component: () => import('@/views/aiChineseMedicine/questionnaire/index')
    },
    {
      path: '/aiChineseMedicine/report',
      name: 'aiChineseMedicineReport',
      component: () => import('@/views/aiChineseMedicine/report/index')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js